var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-3 sku-exceptions-holder"},[_c('header',{staticClass:"mb-4"},[_c('BackButton',{staticClass:"exception-BackButton"}),(!_vm.isEditionOperation())?_c('h3',[_vm._v("Add exception")]):_c('h3',[_vm._v("Edit exception "+_vm._s(_vm.$route.params.id))])],1),_c('client-exception-config')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }